<template>
  <div>
    <div v-if="!paycomplete" class="pb-3" style="font-size:18px">
      {{ titleDetail }}
    </div>
    <div v-if="paycomplete" class="pb-3" style="font-size:18px">
      {{ text.titleDetail }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    paycomplete: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    titleDetail() {
      return this.$options.filters.dbTextDisplay('Detail')
    },
    text() {
      let obj = {}
      if (this.$store.state.language == 'EN') {
        obj = {
          titleDetail: 'Payment Success'
        }
      } else {
        obj = {
          titleDetail: 'ชำระเงินสำเร็จ'
        }
      }
      return obj
    }
  },
  methods: {
    isTextDisplayExist(textname) {
      if (!this.$store.state.textDisplay) return ''
      let t = this.$store.state.textDisplay.filter(item => {
        return item.textname == textname
      })
      return t[0].textdisplay.th
    }
  }
}
</script>
